import React from "react";

const Dashboard = () => {
  return (
    <div>
      <h1 className="text-4xl font-bold md:tracking-tight mt-8 md:text-5xl">
        <span className="text-red-700">Welcome</span> to{" "}
        <span className="text-green-700">To Admin Dashboard </span>
      </h1>
    </div>
  );
};

export default Dashboard;
